function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgErrorIcon = function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 22.2 22.2"
    },
    viewBox: "0 0 22.2 22.2"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.9 18.8 13.2 2C12.3.3 10 .3 9.1 2L.3 18.8c-.8 1.5.3 3.4 2 3.4h17.5c1.8 0 2.9-1.9 2.1-3.4zm-9.4.4H9.7v-2.5h2.8v2.5zm-.3-4.1H9.9l-.3-7.7h2.9l-.3 7.7z",
    style: {
      fill: "#d93a5b"
    }
  }));
};
export default SvgErrorIcon;